<template>
  <div class="login">
    <div class="content">
      <BaseLockup class="lockup-p2"/>
      <div class="main">
        <BaseLottie class="lottie" :path="require('@/assets/lottie/intro-text.json')"/>
      </div>
      <BaseText6 class="subcopy" text="Play Ultimate Staredown now"/>
      <BaseButtonLoginFacebook class="button-fb button" :loading="loading" @click.native="login('facebook')"/>
      <BaseButtonLoginGuest class="button-guest button" @click.native="login('guest')"/>
    </div>
    <BaseVideoAutoplay
      class="video"
      ref="video"
      :video-url="media === 'Mobile' ? require('@/assets/vid/intro-mobile.mp4') : require('@/assets/vid/intro-desktop.mp4')"
      :image-backup-url="media === 'Mobile' ? require('@/assets/img/intro-backup-mobile.jpg') : require('@/assets/img/intro-backup-desktop.jpg')"
    />
  </div>
</template>

<script>
import BaseText6 from '@/components/BaseText6/BaseText6'
import BaseLottie from '@/components/BaseLottie/BaseLottie'
import BaseLockup from '@/components/BaseLockup/BaseLockup'
import BaseButtonLoginFacebook from '@/components/BaseButtonLoginFacebook/BaseButtonLoginFacebook'
import BaseButtonLoginGuest from '@/components/BaseButtonLoginGuest/BaseButtonLoginGuest'
import BaseVideoAutoplay from '@/components/BaseVideoAutoplay/BaseVideoAutoplay'
import getMediaOnLoad from '@/mixins/getMediaOnLoad'
export default {
  name: 'login',
  mixins: [
    getMediaOnLoad
  ],
  components: {
    BaseText6,
    BaseLottie,
    BaseLockup,
    BaseButtonLoginFacebook,
    BaseButtonLoginGuest,
    BaseVideoAutoplay
  },
  data: () => ({
    loading: false
  }),
  methods: {
    async login (authProvider) {
      this.loading = true
      this.$ga.event('login', authProvider)
      const userProfile = await this.$store.dispatch('user/login', authProvider)
      if (!localStorage.getItem('userHasSeenOptin') && userProfile.provider !== 'guest') return this.$router.push('/optin')
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  @media #{$media-3} {
    height: auto;
    margin: auto;
    max-width: 30rem;
  }
}
.content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  z-index: 1;
}
.main {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.lockup-p2 {
  width: 60% !important;
  @media #{$media-3} {
    margin-bottom: 3rem;
  }
}
.lottie {
  width: 90%;
  @media #{$media-3} {
    margin-bottom: 3rem;
    width: 100%;
  }
}
.subcopy,
.button-fb {
  margin-bottom: 1.5rem;
}
.button {
  @media #{$media-3} {
    max-width: 80%;
  }
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
</style>
